import { Observable } from 'rxjs'

export class ModalWindow {
    callbacks = []

    constructor(modalWindowCallback, modalWindowId) {
        this.modalWindow = document.querySelectorAll('.modal-window')
        this.modalBtn = document.querySelectorAll('.modal-window-open-target')
        this.modalClose = document.querySelectorAll('.modal-window-close-target')

        if (modalWindowCallback && modalWindowId) {
            this.callbacks.push({
                id: modalWindowId,
                callback: modalWindowCallback
            })
        }

        this.init()
    }

    init() {
        if (this.modalWindow.length && this.modalBtn.length) {
            Array.prototype.forEach.call(this.modalBtn, btn => {
                Observable.fromEvent(btn, 'click')
                    .subscribe(() => {
                        let modalWindowId = btn.getAttribute('data-modal-id')
                        let modalWindow = document.getElementById(modalWindowId)
                        if (modalWindow) {
                            document.body.classList.add('block-scroll')
                            modalWindow.style.display = 'block'
                        }
                    })
            })
        }

        if (this.modalWindow.length && this.modalClose.length) {
            Array.prototype.forEach.call(this.modalClose, btn => {
                Observable.fromEvent(btn, 'click')
                    .subscribe((event) => {
                        let modalWindowId = event.target.getAttribute('data-modal-id')
                        let modalWindow = document.getElementById(modalWindowId)
                        if (modalWindow && modalWindowId) this.modalCloseFn(modalWindow, modalWindowId)
                    });
            });
        }
    }

    modalCloseFn(modalWindow, modalWindowId) {
        if (modalWindow) {
            document.body.classList.add('open-scroll')
            modalWindow.style.display = 'none'

            if (this.callbacks.length) {
                this.callbacks.forEach(c => {
                    if (c.id === modalWindowId) {
                        c.callback()
                    }
                })
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-window/modal-window.js